/**
 * Common HTTP status codes.
 *
 * @see https://www.codetinkerer.com/2015/12/04/choosing-an-http-status-code.html
 */
export enum HttpStatusCode {
  /**
   * 2xx
   */
  OK = 200,
  Created = 201,
  Accepted = 202,
  NoContent = 204,
  PartialContent = 206,

  /**
   * 4xx
   */
  BadRequest = 400,
  NotAuthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  MethodNotAllowed = 405,
  Conflict = 409,
  PayloadTooLarge = 413,
  TooManyRequests = 429,

  /**
   * 5xx
   */
  InternalServerError = 500,
  NotImplemented = 501,
  ServiceUnavailable = 503,
}
